import { STEP_REGISTRY } from "../registery/stepRegistery";
import type { WorkflowContext } from "../types/workflowContext";
import type { WorkflowStep } from "../types/workflowStep";

export function buildWorkflow(context: WorkflowContext) : WorkflowStep[] {

    const steps: WorkflowStep[] = [];
    // phone
    steps.push(STEP_REGISTRY.PHONE);

    // Existing customers need to enter their PIN
    console.log("context.isExistingCustomer", context.isExistingCustomer);
    if (context.isExistingCustomer) {
        steps.push(STEP_REGISTRY.PIN);
    }

    // country
    steps.push(STEP_REGISTRY.COUNTRY);

    // Optional state step
    if (context.countryHasStates) {
        steps.push(STEP_REGISTRY.STATE);
    }

    // Main journey
    steps.push(STEP_REGISTRY.AMOUNT);
    steps.push(STEP_REGISTRY.HOW_THEY_RECEIVE);
    steps.push(STEP_REGISTRY.REVIEW_AND_EDIT);
    steps.push(STEP_REGISTRY.SENDER_INFO);
    steps.push(STEP_REGISTRY.SENDER_ADDRESS);
    steps.push(STEP_REGISTRY.SENDER_DOB);
    steps.push(STEP_REGISTRY.SENDER_ID1);
    if (context.requiresSecondaryId) {
        steps.push(STEP_REGISTRY.SENDER_ID2);
    }
    steps.push(STEP_REGISTRY.RECEIVER_INFO);
    steps.push(STEP_REGISTRY.FRAUD_PREVENTION);

    // Additional info step only when the app missed collecting required fields
    if (context.requiresAdditionalInfo) {
        steps.push(STEP_REGISTRY.ADDITIONAL_INFO);
    }

    // review
    steps.push(STEP_REGISTRY.FINAL_REVIEW);
    steps.push(STEP_REGISTRY.HEAD_TO_CASHIER);

    // new customer pin creation

    if (!context.isExistingCustomer) {
        steps.push(STEP_REGISTRY.PIN);
    }

    return steps;

}

// why we used function instead of class?
// A function is sufficient for this use case as we are simply taking in a context and returning a list of steps. 
// We don't need the additional features that a class would provide, such as state management or methods. 
// Using a function keeps the code simple and straightforward.

// so this, workflow builder creates Active workFlow. 
// and FlowEngine navigates through the active workflow.

